import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const items = ['Biblioteca de Rituales Aromáticos™', '6 Tomos Premium', '5 Bonos Exclusivos', 'Herramientas listas para implementar', 'Acceso inmediato y de por vida', 'Garantía de 30 días'];
export function FinalCTA() {
  return <section className="w-full bg-[#2a2438] px-5 py-14 text-white" data-id="element-86" data-mp="83m6jnddjcvt">
      <div className="mx-auto max-w-md text-center" data-id="element-87" data-mp="m46q4lr45cqd">
        <h2 className="font-serif-display text-3xl font-bold leading-tight" data-id="element-88" data-mp="m2voosl54h2f">
          Tu marca puede seguir compitiendo por precio…
          <span className="mt-1 block text-[#c9b8ea]" data-id="element-89" data-mp="vv9q1k8b3lo2">o empezar a ser recordada por la experiencia que ofrece.</span>
        </h2>
        <p className="mt-4 text-sm leading-relaxed text-white/70" data-id="element-90" data-mp="qwzu37erch1e">
          La diferencia entre vender un producto y construir una marca no está en cambiar la fórmula.
          Está en cambiar la experiencia. Hoy puedes dar ese paso.
        </p>

        <div className="mt-8 rounded-2xl bg-white p-6 text-[#2a2438]" data-id="element-91" data-mp="2c4oagufi9355">
          <p className="text-xs font-semibold uppercase tracking-widest text-[#7c6aa8]" data-id="element-92" data-mp="2c6hh49q4bnd5">
            Hoy recibirás
          </p>
          <ul className="mt-3 space-y-2 text-left" data-id="element-93" data-mp="2m2uat7lny17w">
            {items.map(i => <li key={i} className="flex items-center gap-2 text-sm text-[#5a5266]" data-id="element-94" data-mp="2m57065tr3duz">
                <CheckIcon className="w-4 h-4 shrink-0 text-[#6f9160]" data-id="element-95" data-mp="2qzufpf6s0xxf" />
                {i}
              </li>)}
          </ul>

          <div className="my-5 h-px w-full bg-[#e4dbcc]" data-id="element-96" data-mp="3023p21qb6l98" />

          <p className="text-xs font-semibold uppercase tracking-widest text-[#7c6aa8]" data-id="element-97" data-mp="300itq9w66yab">
            Todo por un único pago de
          </p>
          <p className="my-1 font-serif-display text-5xl font-bold text-[#3b3350]" data-id="element-98" data-mp="39sych9fajqw9">$12.99 USD</p>
          <p className="mb-5 text-xs text-[#7a7288]" data-id="element-99" data-mp="3es1iaw33i15a">El cambio de moneda es automático a tu país</p>

          <CTAButton label="Quiero descargar mi Biblioteca ahora" data-id="element-100" data-mp="3islh043bhctj" />

          <p className="mt-5 text-[11px] font-medium text-[#7a7288]" data-id="element-101" data-mp="3iqqrech3owj4">
            Descarga inmediata · Pago único · Acceso de por vida · Garantía de 30 días
          </p>
        </div>
      </div>
    </section>;
}